<template>
  <div class="beacon-form-container">
    <p>{{ infoContent }}</p>
    <div v-if="scanQrCode" class="cam-margin">
      <qrcode-stream @decode="onDecode"></qrcode-stream>
    </div>
    <div class="cam-view" v-if="!scanQrCode">
      <input v-model="beaconId" type="text" name="beaconID">
    </div>
    <div class="button-page" @click="scanQrCodeCam">
      <app-button-rect
        :text="scanQrCode ? $t('beacon_management.close_cam') : $t('beacon_management.scan_qrcode')"
        :buttonColor="scanQrCode ? '#d3d3d3' : '#32A6ED'"></app-button-rect>
    </div>
    <div v-if="!scanQrCode">
      <div class="button-page" @click="getBeaconInfo">
        <app-button-rect
          :text="$t('beacon_management.record_beacon')"
          :buttonColor="beaconRecorded ? '#d3d3d3' : '#32A6ED'"></app-button-rect>
      </div>
      <div @click="clearApiKey">
        <app-button-rect
          :text="$t('beacon_management.clear_beacon')"
          :buttonColor="beaconRecorded ? '#ED3D62' : '#d3d3d3'"></app-button-rect>
      </div>
      <div v-if="loadingData">
        <p>{{ $t('settings.loading_data') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { QrcodeStream } from 'vue-qrcode-reader';
import ButtonRect from './ButtonRect.vue';

export default {
  components: {
    'app-button-rect': ButtonRect,
    QrcodeStream,
  },
  data() {
    return {
      beaconId: '',
      loadingData: false,
      beaconRecorded: false,
      scanQrCode: false,
    };
  },
  created() {
    this.beaconId = this.$store.getters.getBeaconShortID;
    if (this.beaconId) {
      this.beaconRecorded = true;
    }
  },
  computed: {
    apikupdated() {
      return this.$store.getters.getApiK;
    },
    infoContent() {
      if (this.scanQrCode) {
        return this.$t('beacon_management.scan_qrcode');
      }
      return this.$t('beacon_management.record_your_beacon_ID_here');
    },
  },
  watch: {
    apikupdated() {
      this.loadingData = false;
    },
  },
  methods: {
    getBeaconInfo() {
      this.loadingData = true;
      this.$store.dispatch('getBeaconInfo', this.beaconId)
        .then((response) => {
          this.loadingData = false;
          if (response === 'ERROR HERE -----> ') {
            this.$store.dispatch('userLogout');
            this.$router.push('login');
          }
          this.beaconRecorded = true;
        })
        .catch((err) => {
          console.err('(!)', err);
          this.loadingData = false;
        });
    },
    clearApiKey() {
      this.beaconId = '';
      this.beaconRecorded = false;
      this.$store.dispatch('clearApiKey');
    },
    scanQrCodeCam() {
      this.scanQrCode = !this.scanQrCode;
      this.$emit('scanView', this.scanQrCode);
    },
    onDecode(evt) {
      this.beaconId = evt;
      this.scanQrCode = false;
      this.$emit('scanView', this.scanQrCode);
    },
  },
};
</script>

<style scoped>
  input {
    border: solid 1px grey;
    height: 50px;
    width: 100%;
    font-size: 22px;
    color: grey;
    text-align: center;
    margin-bottom: 24px;
  }

  .beacon-form-container {
    padding: 5%;
    padding-top: 0vh;
  }

  .button-page {
    margin-bottom: 24px;
  }

  .cam-margin {
    margin-bottom: 24px;
  }
</style>
